module.exports = {
          srcSet: __webpack_public_path__ + "be852797f0c872dbaf8a062ced5f2485-245.png"+" 245w",
          images:[ {path: __webpack_public_path__ + "be852797f0c872dbaf8a062ced5f2485-245.png",width: 245,height: 236}],
          src: __webpack_public_path__ + "be852797f0c872dbaf8a062ced5f2485-245.png",
          toString:function(){return __webpack_public_path__ + "be852797f0c872dbaf8a062ced5f2485-245.png"},
          
          width: 245,
          height: 236
        }